import { combineReducers } from 'redux';

import homepage from './homepage';
import search from './search';
import detail from './detail';
import browseBy from './browseBy';
import advancedFilter from './advancedFilter';
import chartReducer from './chart-reducer';


export default combineReducers({
  homepage,
  search,
  detail,
  browseBy,
  advancedFilter,
  chartReducer
});



// WEBPACK FOOTER //
// ./src/app/reducers/index.js